/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ic-list-column-header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:11px}.ic-list-column-header div[actions] div{position:absolute;right:60px}.ic-list-column-header.sortable{cursor:pointer}.ic-list-column-header .indicator{margin-left:1rem}.ic-list-column-header .indicator .fa{display:block;line-height:.2}.ic-list-column-header .indicator .fa.active{color:#41abf3}.ic-list-column-header>*{-webkit-box-flex:1;-ms-flex:1;flex:1}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/list/column.header/list.column.header.component.scss.ngstyle.js.pre-build-optimizer.js